import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHugSelectedEmojiSecondary from './svgs/HugSelectedEmojiSecondary.js';
import SvgHugSelectedEmoji from './svgs/HugSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hugSelectedEmoji = (props => useIcon(SvgHugSelectedEmoji, SvgHugSelectedEmojiSecondary, props));

export { hugSelectedEmoji as default };
